import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=2edbb1d2&"
import script from "./step_4.vue?vue&type=script&lang=ts&"
export * from "./step_4.vue?vue&type=script&lang=ts&"
import style0 from "./step_4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports